import { h, Component, Fragment } from 'preact';

export default class TsunamiInfoComponent extends Component {
    constructor() {
        super();
        // should match the 'name' attribute in the region configuration
        this.hawaiiCode = "Hawai'i";
        this.guamCode = 'Guam';
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <aside class={`modal-full-page ${self.props.isOpen ? 'is-open' : ''}`}>
                    <button class="btn-close--dark" onclick={self.props.close}>
                        &times;
                    </button>
                    <section role="document" class="content">

                        {/* TSUNAMI WARNING SECTION */}
                        <article>

                            <h1 class="section-head">Tsunami Warning</h1>

                            {/* Warning Signs */}
                            <h2 class="font-light">Know the Natural Warning Signs of a Tsunami -  use your senses!</h2>

                            <h3>FEEL</h3>
                            <p><em>Feel the ground shaking severely?</em></p>
                            <p>Head for higher ground. Strong local earthquakes may cause tsunamis.</p>

                            <h3>SEE</h3>
                            <p><em>See an unusual disappearance of water, or an oncoming wall of water?</em></p>
                            <p>Immediately leave low-lying coastal areas and move inland. As a tsunami approaches the shoreline, sea levels often recede,exposing the ocean floor, reef, and fish.</p>

                            <h3>HEAR</h3>
                            <p><em>Hear the roar?</em></p>
                            <p>An approaching tsunami may create a loud “roaring” similar to the sound of a moving train or jet aircraft.</p>

                            <a href="http://itic.ioc-unesco.org/images/stories/awareness_and_education/tsunami_safety_flyers/sensing_a_tsunami_en_20130912.pdf" title="Download Warning Signs PDF" target="_blank" rel="noreferrer" class="link-block--dark">Find and Share a Printable Version of this Information</a>

                            {/* Warning System */}
                            <h2>Official Tsunami Warnings</h2>

                            <p>NOAA’s <a href="https://www.tsunami.gov/" title="Go to Tsunami Warning Center site" target="_blank" rel="noreferrer">Tsunami Warning Center</a> (TWC) is responsible for tsunami monitoring and issuing necessary watches or warnings for Hawai‘i and the U.S. Pacific Islands.</p>

                            <h3>Tsunami Message Definitions</h3>

                            <p><strong><span class="text-important">Tsunami Warning:</span> Take Action</strong>- Danger! A tsunami that may cause widespread flooding is expected or occurring. Dangerous coastal flooding and powerful currents are possible and may continue for several hours or days after initial arrival.
                                Follow instructions from local officials. Evacuation is recommended. Move to high ground or inland (away from the water).</p>

                            <p><strong><span class="text-important">Tsunami Advisory:</span> Take Action</strong>- A tsunami with potential for strong currents or waves dangerous to those in or very near the water is expected or occurring. There may be flooding of beach and harbor areas. Stay out of the water and away from beaches and waterways. Follow instructions from local officials.</p>

                            <p><strong><span class="text-important">Tsunami Watch:</span> Be Aware</strong>- A distant earthquake has occurred. A tsunami is possible.  Stay tuned for more information. Be prepared to take action if necessary.</p>

                            <p><strong><span class="text-important">Tsunami Information Statement:</span> Relax</strong>- An earthquake has occurred, or a tsunami warning, advisory or watch has been issued for another part of the ocean. Most information statements indicate there is no threat of a destructive tsunami.</p>

                            {/* Emergency Information */}
                            <h2>Emergency Information</h2>
                            <p>The <strong>Emergency Alert System</strong>, often called the EAS, is used to notify the public of approaching hazards. The EAS will be activated along with other warning methods such as the Outdoor Siren Warning System, Wireless Emergency Alerts, and local emergency notification systems.</p>

                            <p>If you are alerted about a tsunami hazard by any of the above methods, turn on the nearest radio or television and listen for emergency information and instructions.</p>

                            {self.props.selectedRegion.name === self.hawaiiCode &&
                            <div>{/* HAWAII CONTENT */}
                                <p>Foreign language emergency broadcasts can be found on the following stations: KZOO 1210AM (Japanese), KREA 1540AM (Korean), and KNDI 1270AM (variety of Pacific Islander languages).</p>

                                <a href="https://dod.hawaii.gov/hiema/" title="Go to Hawai'i Emergency Management Agency" target="_blank" rel="noreferrer" class="link-block--dark">Hawai'i Emergency Management Agency</a>
                            </div>}
                            {self.props.selectedRegion.name === self.guamCode &&
                            <div>{/* GUAM CONTENT */}
                                <h5>Guam Homeland Security</h5>

                                <a href="http://ghs.guam.gov/" title="Go to Guam Homeland Security Office of Civil Defense" target="_blank" rel="noreferrer" class="link-block--dark">Guam Homeland Security Office of Civil Defense</a>
                            </div> }

                        </article>

                        {/* TSUNAMI EVACUATION SECTION */}
                        <article>

                            <h1 class="section-head">Tsunami Evacuation</h1>

                            <p>If you are in a low-lying area near the coast or in the tsunami evacuation zone and you feel shaking that causes you to fall or have difficulty standing, get to higher ground immediately. A locally generated tsunami could reach the shore within minutes!</p>

                            <h2>Evacuation Tips</h2>
                            <p>Tune in to your local television or radio stations for the most up-to-date information about tsunami evacuation centers in your area.</p>

                            {self.props.selectedRegion.name === self.hawaiiCode &&
                            <div> {/* HAWAII CONTENT */}
                                <p>For questions about evacuation procedures in your community, contact your county emergency management agency:</p>

                                <ul>
                                    <li>
                                        <a title="Go to site" target="_blank" rel="noreferrer" href="http://www.honolulu.gov/dem">City and County of Honolulu Department of Emergency Management</a>
                                    </li>
                                    <li>
                                        <a title="Go to site" target="_blank" rel="noreferrer" href="http://www.co.maui.hi.us/departments/CivilDefense/">Maui Emergency Management Agency</a>
                                    </li>
                                    <li>
                                        <a title="Go to site" target="_blank" rel="noreferrer" href="http://www.kauai.gov/Government/Departments/CivilDefenseAgency/tabid/90/Default.aspx">Kauai Emergency Management Agency</a>
                                    </li>
                                    <li>
                                        <a title="Go to site" target="_blank" rel="noreferrer" href="http://www.hawaiicounty.gov/civil-defense/">Hawai'i County Emergency Management Agency</a>
                                    </li>
                                </ul>
                            </div>}
                            {self.props.selectedRegion.name === self.guamCode &&
                            <div> {/* GUAM CONTENT */}
                                <p>For questions about evacuation procedures in your community, contact your local emergency management agency:</p>
                                <ul>
                                    <li>
                                        <a title="Go to Guam Homeland Security Office of Civil Defense" target="_blank" rel="noreferrer" href="http://ghs.guam.gov/">Guam Homeland Security Office of Civil Defense</a>
                                    </li>
                                </ul>
                            </div>}

                            <h2>When Sirens Sound</h2>
                            {self.props.selectedRegion.name === self.hawaiiCode &&
                            <div>{/* HAWAII CONTENT */}
                                <p>Follow the instructions issued by local officials.</p>
                            </div>}
                            {self.props.selectedRegion.name === self.guamCode &&
                            <div>{/* GUAM CONTENT */}
                                <p>First responders from the government of Guam will drive through villages with sirens and provide information about what to do. Follow the instructions issued by local officials.</p>
                            </div>}

                            <p>If you are in the evacuation zone, prepare to move inland. If located outside a tsunami evacuation zone, stay outside of the evacuation zone and limit all non-emergency travel.</p>

                            <p>For strong local earthquakes, if you have access to an undamaged concrete or steel reinforced building
                                {self.showExtraLegned && <span> of ten or more stories, move to the fourth floor, or above, and stay put.</span>}
                                {!self.showExtraLegned && <span> of six or more stories, move above the third floor and stay put.</span>}
                            </p>

                            <p>For distance-source tsunamis, you may have more time to react. A Tsunami Warning will be issued three or more hours before the estimated arrival time.  If you are in the evacuation zone when the warning sirens sound, prepare to move inland, or if you have access to a concrete or steel reinforced building of six or more stories, move above the third floor and stay put.</p>

                            <ul>
                                <li>
                                    <strong>Avoid traffic gridlock!</strong> It may be safer and more efficient to walk out of the tsunami evacuation zone.
                                </li>

                                <li>
                                    <strong>Remain outside the evacuation zone</strong> until local officials tell you that it is safe to return.
                                </li>

                                <li>
                                    <strong>Do not use your telephone or make calls on your cell phone</strong> except for emergencies (texting and data use is ok).
                                </li>

                                <li>
                                    <strong>Save yourself</strong>, not your possessions.
                                </li>
                                {self.props.selectedRegion.name === self.hawaiiCode &&
                                <div>{/* HAWAII CONTENT */}
                                    <li>
                                        <strong>Remember, all public schools in tsunami evacuation zones</strong> have emergency evacuation plans in the event of a Tsunami Warning.
                                    </li>
                                </div>}

                            </ul>

                        </article>

                        {/* TSUNAMI PLAN SECTION */}
                        <article>

                            <h1 class="section-head">Tsunami Plan</h1>

                            <p>You cannot prevent a tsunami, but you can be prepared for one. Actions you take now could save your life and the lives of your loved ones.</p>

                            <h2>Develop a Family Emergency Plan</h2>

                            <p>Prepare yourself and your family for a disaster by making an emergency plan. Your family may not be together when disaster strikes, so it is important to plan in advance.</p>

                            {self.props.selectedRegion.name === self.hawaiiCode &&
                            <div>{/* HAWAII CONTENT */}
                                <p>Create your <a href="https://dod.hawaii.gov/hiema/get-ready/prepare-your-family/" title="Download PDF" target="_blank" rel="noreferrer">Family Emergency Plan</a>, and visit the <a href="https://dod.hawaii.gov/hiema/public-resources/preparedness-information/" target="_blank" rel="noreferrer">Hawai‘i Emergency Management Agency</a> website for more preparedness information.</p>
                            </div>}
                            {self.props.selectedRegion.name === self.guamCode &&
                            <div>{/* GUAM CONTENT */}
                                <p>Create your <a href="https://www.ghs.guam.gov/outreach/citizens-preparedness/make-plan" title="Download PDF" target="_blank" rel="noreferrer">Family Emergency Plan</a>, and visit the <a href="https://www.ghs.guam.gov/programs/natural-disasters/tsunamis" target="_blank" rel="noreferrer">Guam Civil Defense</a> website for more preparedness information.</p>
                            </div>}

                            <p><strong>Don’t Forget about Your Pets</strong></p>
                            <p>Have <a href="http://www.ready.gov/caring-animals" target="_blank" rel="noreferrer">preparations</a> in place to care for your pets in case you are ordered to evacuate.</p>

                            <div class="clearfix"></div>

                            <h2>Assemble an Emergency Preparedness Kit</h2>

                            <p>Emergency kits should contain the essentials your family needs to survive during a disaster. You may be on your own for three days or more before emergency personnel reach you.</p>

                            <p>
                                <a href="https://www.ready.gov/sites/default/files/2020-03/ready_emergency-supply-kit-checklist.pdf" title="Download the Emergency Preparedness Kit Checklist" target="_blank" rel="noreferrer" class="btn-default block">Access and develop your emergency preparedness kit</a>.

                            </p>

                            <h2>Plan Ahead</h2>
                            <p>Become familiar with potential evacuation routes, develop an evacuation plan, and update your plan when issues arise.</p>
                            <p>Practice your evacuation plan at least twice a year with your family so that when a tsunami occurs, you are prepared to act!</p>
                            <p>Keep in mind that hundreds of families in your area share the same concerns, and it may be difficult to access supplies because of shortages and competition.</p>

                            {self.props.selectedRegion.name === self.hawaiiCode &&
                            <div>{/* HAWAII CONTENT */}
                                <h2>Sign Up</h2>

                                <p>Sign up to be included in your local emergency notification system</p>
                                <ul>
                                    <li>
                                        <a title="Go to site" target="_blank" rel="noreferrer" href="http://ww2.citywatchonline.com/Public/Signup.aspx?SUID=jMsd45DCLtpnkuC41zEKNw===" class="btn-default signup-btn">Hawaii</a>
                                    </li>
                                    <li>
                                        <a title="Go to site" target="_blank" rel="noreferrer" href="http://www.co.maui.hi.us/list.aspx" class="btn-default signup-btn">Maui</a>
                                    </li>
                                    <li>
                                        <a title="Go to site" target="_blank" rel="noreferrer" href="https://countyofkauai.bbcportal.com/" class="btn-default signup-btn">Kauai</a>
                                    </li>
                                    <li>
                                        <a title="Go to site" target="_blank" rel="noreferrer" href="http://www.honolulu.gov/dem/preparedness/stay-informed.html" class="btn-default signup-btn">Oahu</a>
                                    </li>
                                </ul>
                            </div>}
                        </article>

                        {/* TSUNAMI RISK SECTION */}
                        <article>

                            <h1 class="section-head">Tsunami Risk</h1>
                            <p>Knowledge is safety. To reduce your risk, know your tsunami facts.</p>

                            <h2>What is a tsunami?</h2>
                            <p>A tsunami (Japanese for “harbor waves”) is a series of ocean waves produced by a sudden rise or fall in the earth’s crust, most commonly caused by an earthquake or underwater landslide.</p>

                            <p>In the open ocean, tsunami waves cannot be seen or felt by ships or airplanes because the waves are actually hundreds of miles wide, with a height of only a few feet. But as the waves approach the coast, their height increases dramatically and can be very destructive when they reach the shore.</p>

                            <p><a href="https://youtu.be/OLZA4wMaFf0" title="watch video" target="_blank" rel="noreferrer">Tsunami Mikenna educational video</a></p>

                            <h2>Understand the Threat</h2>
                            <ol>
                                {self.props.selectedRegion.name === self.hawaiiCode &&
                                <span>{/* HAWAII CONTENT */}<li><strong>Tsunamis are Hawai'i's number one</strong> natural disaster killer.</li></span>
                                }
                                {self.props.selectedRegion.name === self.guamCode &&
                                <span>{/* GUAM CONTENT */}<li><strong>Tsunamis are Guam's number one</strong> natural disaster killer.</li></span>
                                }

                                <li><strong>All low-lying coastal areas, harbors, streams, and rivers</strong> in Hawai‘i are vulnerable to tsunami impacts.</li>

                                <li><strong>Tsunamis can occur at any time</strong>. Earthquakes or landslides that may trigger tsunamis cannot be forecast.</li>
                            </ol>

                            <h3>Local Tsunamis vs. Distant Source Tsunamis</h3>
                            <p>Locally generated tsunamis can arrive at the coast within minutes, even before a warning can be issued.</p>
                            <p>All islands are also vulnerable to distant-source tsunamis. These tsunamis result from distant earthquakes or landslides in places like Chile, Alaska, and Japan, and can arrive within hours.</p>

                            <h3>Visit these resources for additional tsunami information:</h3>
                            <ul>
                                <li>
                                    <a href="http://itic.ioc-unesco.org/index.php" target="_blank" rel="noreferrer">International Tsunami Information Center</a>
                                </li>
                                <li>
                                    <a href="http://www.nws.noaa.gov/om/Tsunami/index.html" target="_blank" rel="noreferrer">National Weather Service Tsunami Safety Website</a>
                                </li>
                                <li>
                                    <a href="http://www.tsunami.noaa.gov/" target="_blank" rel="noreferrer">NOAA Tsunami Website</a>
                                </li>
                                <li>
                                    <a href="http://tsunami.org/" target="_blank" rel="noreferrer">Pacific Tsunami Museum</a>
                                </li>
                                <li>
                                    <a href="https://www.meted.ucar.edu/training_module.php?id=813" target="_blank" rel="noreferrer">Tsunami Strike! Pacific Edition</a>
                                </li>
                                <li>
                                    <a href="https://ndptc.hawaii.edu/" target="_blank" rel="noreferrer">National Disaster Preparedness Training Center</a>
                                </li>
                            </ul>

                        </article>
                    </section>
                </aside>
            </Fragment>
        );
    }
}
